import { StatusPair } from '../models/status-pair';

export class DateData {
    private month: StatusPair[] = [new StatusPair('JAN', '1'),
    new StatusPair('FEB', '2'),
    new StatusPair('MAR', '3'),
    new StatusPair('APR', '4'),
    new StatusPair('MAY', '5'),
    new StatusPair('JUN', '6'),
    new StatusPair('JUL', '7'),
    new StatusPair('AUG', '8'),
    new StatusPair('SEP', '9'),
    new StatusPair('OCT', '10'),
    new StatusPair('NOV', '11'),
    new StatusPair('DEC', '12')];

    public getMonths(): Array<StatusPair> {
        return this.month;
    }

    public getYears(): Array<string> {
        let years = new Array<string>();
        const currentYear = new Date().getFullYear();
        for (let i = currentYear; i >= 1900; i--) {
            years.push(i.toString());
        }

        return years;
    }

    public getDays(month: number, year: number): Array<string> {
        let days = new Array<string>();
        const now = new Date();
        if (!year) {
            year = now.getFullYear();
        }
        if (!month) {
            year = now.getMonth();
        }
        const daysAmount = new Date(year, month, 0).getDate();
        for (let i = 1; i <= daysAmount; i++) {
            days.push(i.toString());
        }
        return days;
    }
}
